/**
 * ProductCard Component
 * Displays a jewelry product card with image and details
 */

import React from 'react';

interface ProductCardProps {
  title: string;
  imageUrl: string;
  description: string;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  title,
  imageUrl,
  description,
}) => {
  return (
    <div className="bg-gray-800 border border-yellow-600 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
      <div className="aspect-square overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4">
        <h4 className="text-yellow-500 text-lg font-semibold mb-2">{title}</h4>
        <p className="text-gray-300 text-sm">{description}</p>
      </div>
    </div>
  );
};
